export const ITEM_VISIBILITY_RULES = {
  supports: ({ modulos }) => modulos?.Supports,
  mudanzas: ({ modulos }) => modulos?.Mudanza,
  mascotas: ({ modulos }) => modulos?.Pets,
  listas: ({ modulos }) => !modulos?.NoFamilyGuard,
  familia: ({ modulos }) => !modulos?.NoFamilyGuard,
  gestionarGuardias: ({ modulos }) => !modulos?.NoFamilyGuard,
  aprobadores: ({ modulos }) => modulos?.Aprobadores,
  config: ({ user }) => !user?.roles?.parkeyDigitador,
}

export const SUB_ITEM_VISIBILITY_RULES = {
  placas: ({ modulos }) => modulos?.PlacasResidentes,
  tags: ({ modulos }) => modulos?.TagsResidentes,
  rostros: ({ modulos }) => modulos?.RostrosResidentes,
  proformas: ({ modulos }) => modulos?.Proforma,
  bloques: ({ modulos }) => modulos?.Bloques,
}
